<template>
  <div style="">
    <div style="font-size: 18px;line-height: 1.8em;">
      {{ getPos }}
    </div>
      <el-button size="mini" @click="del">删除</el-button>
  </div>
</template>

<script>
import formatter from '@/util/geoUtil'

export default {
  name: 'MarkerPopup',
  props: {
    params: Object
  },
  computed: {
     getPos(){
      let latlng=this.params.marker.getLatLng()
      return formatter.formatLatlng(latlng)
     }
  },
  data() {
    return {
        

    }
  },
  watch: {
   

  },
  mounted: function () {
   
  },
  methods: {
   del(){
    this.params.marker.remove()
   }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-row {
  margin-bottom: 8px;
  line-height: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-radio {
  margin-right: 0px !important;
}

.right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/main/MarkerPopup.vue